import React, { useEffect } from 'react';
import { makeStyles, Divider, Box } from "@material-ui/core";
import Botao from "../../../shared/components/Botao";
import {
    CODIGO_TECLA_S,
    CODIGO_TECLA_ESC,
} from "../../../shared/utils/Constantes";

const BotoesCadastro = ({
    handleSubmit,
    handleGoBack,
    isValid,
    carregando
}) => {
    const classes = useStyles();

    useEffect(() => {
        const submitShortcut = (event) => {
            if (isValid && event.ctrlKey && event.which === CODIGO_TECLA_S) {
                event.preventDefault();
                handleSubmit();
            }
        }

        if (isValid) {
            document.addEventListener('keydown', submitShortcut);
        }
        else {
            document.removeEventListener('keydown', submitShortcut);
        }

        return () => document.removeEventListener('keydown', submitShortcut);
    }, [isValid, handleSubmit]);

    useEffect(() => {
        const cancelShortcut = (event) => {            
            if (event.which === CODIGO_TECLA_ESC) {
                event.preventDefault();
                handleGoBack();
            }
        }

        document.addEventListener('keydown', cancelShortcut);

        return () => document.removeEventListener('keydown', cancelShortcut);
    }, [handleGoBack]);

    return (
        <>
            <Divider className="mb-3" />
            <Box display="flex" justifyContent="flex-end">
                <Botao
                    id="cancelar"
                    type="secondary"
                    className={classes.botao + " mr-8"}
                    titulo="Cancelar"
                    atalho="(ESC)"
                    onClick={handleGoBack}
                    carregando={carregando}
                />
                <Botao
                    id="finalizarCadastro"
                    type="primary"
                    className={classes.botao}
                    titulo="Finalizar cadastro"
                    atalho="(CTRL + S)"
                    onClick={handleSubmit}
                    disabled={!isValid}
                    carregando={carregando}
                />
            </Box>
        </>
    );
}

const useStyles = makeStyles((theme) => ({
    botao: {
        height: "56px",
        width: "316px"
    },
}));

export default BotoesCadastro;